import { Heading, Link, View, useVisibility } from '@fold-dev/core'
import { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router'
import { Block, Error, Loading } from '../components'
import { byName, logger } from '../helpers/util'
import { useWorkspaces } from '../hooks/api.hooks'
import WorkspaceOnboardingModal from '../modals/workspace-onboarding.modal'
import { useAuth } from '../hooks/auth.hook'

export const WorkspacesView = (props: any) => {
    const navigate = useNavigate()
    const { workspaceId } = useParams()
    const { getAll } = useWorkspaces()
    const [workspaces, setWorkspaces] = useState([])
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState<any>('')
    const onboardingModal = useVisibility()
    const { logout } = useAuth()

    const fetchData = async () => {
        setLoading(true)
        setError(null)

        try {
            const workspaces = await getAll()
            setLoading(false)
            setWorkspaces(workspaces.sort(byName))
        } catch (e) {
            logger(e)
            setLoading(false)
            setError('Could not fetch workspaces')
        }
    }

    useEffect(() => {
        fetchData()
    }, [])

    return (
        <>
            {onboardingModal.visible && (
                <WorkspaceOnboardingModal
                    onCreate={fetchData}
                    onDismiss={onboardingModal.hide}
                />
            )}

            <View
                column
                bg="linear-gradient(45deg, var(--f-color-surface), var(--f-color-surface-strong))"
                gap="2rem"
                position="absolute"
                width="100%"
                height="100%"
                style={
                    {
                        'inset': 0,
                        '--f-button-color': 'var(--f-color-base-600)',
                        '--f-button-color-hover': 'var(--f-color-base-400)',
                        '--f-button-background-color-hover': 'var(--f-color-base-800)',
                        '--f-focus': '2px solid var(--f-color-accent-800)',
                        '--f-avatar-background-color': 'var(--f-color-base-900)',
                        '--f-image-background-color': 'var(--f-color-base-900)',
                        '--f-avatar-badge-outline': '0.2rem solid var(--f-color-base-900)',
                    } as any
                }>
                <Loading loading={loading} />
                <Error error={error} />
                <Heading
                    as="h3"
                    colorToken="text-weaker">
                    Choose a Workspace:
                </Heading>
                <View
                    row
                    width={300}
                    gap="1rem"
                    style={{ flexWrap: 'wrap' }}>
                    {workspaces.map((workspace: any, index: number) => (
                        <Block
                            key={index}
                            className="f-buttonize"
                            name={workspace.name}
                            src={workspace.image}
                            onClick={() => navigate(`/app/workspace/${workspace.id}/today`)}
                            size="xl"
                            style={{
                                outlineOffset: 2,
                                outline: workspace.id == workspaceId ? '2px solid var(--f-color-accent-400)' : null,
                            }}
                        />
                    ))}

                    <Block
                        className="f-buttonize"
                        icon="plus"
                        name=""
                        src=""
                        onClick={onboardingModal.show}
                        size="xl"
                    />
                </View>
                <Link
                    onClick={logout}
                    className="f-underline"
                    colorToken="text-weaker">
                    Logout
                </Link>
            </View>
        </>
    )
}
